import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import HighwayUnpaidEditSearchForm from '@di-shared/features/public-service/highway-unpaid/HighwayUnpaidEditSearchForm';

export interface HighwayUnpaidEditSearchPageProps {
  vin: string;
  licensePlateNumber: string;
}

function HighwayUnpaidEditSearchPage({vin, licensePlateNumber}: HighwayUnpaidEditSearchPageProps) {
  return (
    <div className="wrap">
      <Header left={<HeaderBackButton />}>
        <h1 className="title_xsmall_b nav_center_title">고속도로 미납통행료 조회</h1>
      </Header>

      <HighwayUnpaidEditSearchForm
        vin={vin}
        licensePlateNumber={licensePlateNumber}
      />
    </div>
  );
}

export default HighwayUnpaidEditSearchPage;
